import { Calendar, Filter, Search, X } from 'lucide-react';
import { DocumentsDateFilter } from './DocumentsDateFilter';
import { DocumentsSearchField } from './DocumentsSearchField';
import { DocumentsTypeFilter } from './DocumentsTypeFilter';

function DocumentsResetFiltersButton({ setTypeFilter, setDateFilter }) {
  return (
    <button
      type="button"
      data-testid="documents-reset-filters"
      onClick={() => {
        setTypeFilter('all');
        setDateFilter('all');
      }}
      className="flex h-9 items-center gap-1 rounded-sm border border-zinc-700 bg-zinc-800 px-3 text-sm text-zinc-300 transition-colors hover:bg-zinc-700"
    >
      <X className="h-3 w-3" />
      Réinitialiser
    </button>
  );
}

function DocumentsResultsCount({ filteredCount, totalCount }) {
  const pluralSuffix = filteredCount > 1 ? 's' : '';
  const filteredSuffix = filteredCount !== totalCount ? ` sur ${totalCount}` : '';

  return (
    <div data-testid="documents-results-count" className="text-xs text-muted-foreground">
      {filteredCount} document{pluralSuffix} affiché{pluralSuffix}
      {filteredSuffix}
    </div>
  );
}

export function DocumentsFiltersBar({
  documents,
  filteredDocuments,
  searchQuery,
  setSearchQuery,
  typeFilter,
  setTypeFilter,
  dateFilter,
  setDateFilter,
}) {
  const pdfCount = documents.filter((document) => document.source_type === 'pdf').length;
  const webCount = documents.filter((document) => document.source_type === 'web').length;
  const hasActiveFilters = typeFilter !== 'all' || dateFilter !== 'all';

  return (
    <div className="mb-6 space-y-4" data-testid="documents-filters-bar">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-zinc-600" />
        <DocumentsSearchField searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      </div>

      <div className="flex flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <Filter className="h-4 w-4 text-zinc-500" />
          <DocumentsTypeFilter
            documentsCount={documents.length}
            pdfCount={pdfCount}
            webCount={webCount}
            typeFilter={typeFilter}
            setTypeFilter={setTypeFilter}
          />
        </div>

        <div className="flex items-center gap-2">
          <Calendar className="h-4 w-4 text-zinc-500" />
          <DocumentsDateFilter dateFilter={dateFilter} setDateFilter={setDateFilter} />
        </div>

        {hasActiveFilters ? (
          <DocumentsResetFiltersButton setTypeFilter={setTypeFilter} setDateFilter={setDateFilter} />
        ) : null}
      </div>

      <DocumentsResultsCount filteredCount={filteredDocuments.length} totalCount={documents.length} />
    </div>
  );
}
